<template>
  <div class="container-mapas">
    <div class="left-box">
      <div class="title-section">
        <h2>Sudeste</h2>
      </div>
      <div>
          <!-- <p class="texto-apoio">Minas Gerais, São Paulo, Espírito Santo e Rio de Janeiro fazem parte da região Sudeste, coincidente com a região geográfica homônima.</p> -->
          <div class="downloand">
              <ul>
								  <li>
                      <p>Fichas da Região</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Sudeste.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Espírito Santo - ES</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Espirito Santo.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Minas Gerais - MG</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Minas Gerais.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Rio de Janeiro - RJ</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Rio de Janeiro.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>São Paulo - SP</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Sao Paulo.zip" target="_blank">Download</a>
                  </li>
              </ul>
          </div>
          <div class="interacao-intervencao">
			<svg xmlns="http://www.w3.org/2000/svg" width="15" height="22" viewBox="0 0 15 22">
    			<path fill="#7E7E7E" fill-rule="evenodd" d="M13.278 12.965l-5.436-.492-.008-6.237C7.834 5.8 7.464 5 6.57 5c-.695 0-1.264.554-1.264 1.236V16.74l-1.049-1.473a1.255 1.255 0 0 0-1.894-.162 1.206 1.206 0 0 0-.141 1.559L4.94 21.62c.235.335.623.38 1.037.38h6.086c1.201 0 2.234-.678 2.47-1.832l.418-4.45c.249-1.223-.469-2.359-1.673-2.753M1.3 9C.582 9 0 8.464 0 7.8V6.3c0-8.4 13-8.4 13 0v1.5c0 .664-.582 1.2-1.3 1.2-.718 0-1.3-.536-1.3-1.2V6.3c0-4.8-7.8-4.8-7.8 0v1.5c0 .664-.582 1.2-1.3 1.2"/>
			</svg>
			<p>Explore o mapa e tenha acesso aos detalhes e à ficha-modelo de cada intervenção.</p>
		  </div>
      </div>
    </div>
    <div class="right-box">
      <div class="mapa">
				 <Modal />
         <SvgPanZoom :dblClickZoomEnabled="false" :zoomEnabled="true" :controlIconsEnabled="true" :fit="false"  :center="true" :contain="true">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 1076 1068" style="enable-background:new 0 0 1076 1068;" xml:space="preserve">
<polygon class="st0" points="917.7,398.8 916,409.9 915.6,410.5 778.6,663.8 619.9,684.3 619.8,682.9 625.7,674.7 773,655.6
	821,566.8 826.2,566.5 825.8,557.8 907.5,407 908,403.8 912.5,406.4 916.9,398.6 "/>
<polygon class="st0" points="916.9,398.6 912.5,406.4 908,403.8 909.4,394.5 "/>
<polygon class="st0" points="909.4,394.5 908,403.8 864.5,379.5 868.3,377.4 869.6,372.2 "/>
<polygon class="st1" points="908,403.8 907.5,407 825.8,557.8 825.8,557.7 794,559.1 771.2,531.5 820.7,404.1 864.5,379.5 "/>
<polygon class="st0" points="893.3,278.8 869.6,372.2 866.6,370.5 862.3,378.3 864.5,379.5 820.7,404.1 771.2,531.5 769.5,529.4
	762.7,535.1 767.5,540.9 748.1,590.8 594.6,640.3 560.8,644.2 560.1,642.2 741.4,583.7 813.6,397.9 860.6,371.5 882.9,283.8
	662,184.2 549.7,235.1 526.5,203.7 485.8,274.1 455.7,409.7 347,415.7 274.3,459.1 267.3,454.7 266.6,453.4 344.4,407 345.4,406.9
	448.5,401.2 475.4,280.2 475.8,280.2 475.8,278.6 477.5,270.8 521.6,194.3 521.6,195.3 530.4,195.8 530.5,194.2 552.5,224.1
	662,174.5 "/>
<polygon class="st1" points="882.9,283.8 860.6,371.5 813.6,397.9 741.4,583.7 564.1,643.8 560.8,644.2 531.8,647.5 469.9,488.1
	254.9,497 267.3,467.5 274.3,459.1 347,415.7 455.7,409.7 485.8,274.1 526.5,203.7 549.7,235.1 662,184.2 "/>
<polygon class="st0" points="866.6,370.5 869.6,372.2 868.3,377.4 864.5,379.5 862.3,378.3 "/>
<polygon class="st0" points="825.8,557.8 826.2,566.5 821,566.8 "/>
<polygon class="st0" points="825.8,557.7 825.8,557.8 821,566.8 790,568.1 767.5,540.9 771.2,531.5 794,559.1 "/>
<polygon class="st1" points="821,566.8 773,655.6 625.7,674.7 655.1,633.4 594.6,640.3 748.1,590.8 767.5,540.9 790,568.1 "/>
<polygon class="st0" points="769.5,529.4 771.2,531.5 767.5,540.9 762.7,535.1 "/>
<polygon class="st0" points="655.1,633.4 625.7,674.7 614.9,676 613.2,676.8 636.3,644.5 526,657.1 463.9,497.2 252.9,506
	258.9,496.8 469.9,488.1 531.8,647.5 560.8,644.2 562.8,650.6 594.6,640.3 "/>
<path class="st1" d="M636.3,644.5l-23.1,32.3l-181,83.1l-2.8,8.7l-68.4-29.5l-29.9-86.6l-2.9-0.3c-53.5-5-137.7-13.8-159.4-18.2
	L242.9,506l221-8.7L526,657.1L636.3,644.5z"/>
<polygon class="st0" points="625.7,674.7 619.8,682.9 612.5,677.8 613.2,676.8 614.9,676 "/>
<polygon class="st0" points="619.8,682.9 619.9,684.3 617.4,684.7 439.5,766.3 437.6,772.2 429.4,768.6 432.2,759.9 613.2,676.8
	612.5,677.8 "/>
<polygon class="st0" points="594.6,640.3 562.8,650.6 560.8,644.2 "/>
<line class="st2" x1="437.6" y1="772.2" x2="438.4" y2="772.5"/>
<polyline class="st0" points="427.4,777.4 426.7,777.1 429.4,768.6 437.6,772.2 "/>
<path class="st0" d="M429.4,768.6l-2.7,8.5L354,745.7l-29.3-84.9c-10-1-44.9-4.3-79.6-8.1c-24-2.6-43.2-4.9-57.2-6.8
	c-8.3-1.1-14.8-2.1-19.3-3c-2.3-0.5-4.2-0.8-5.7-1.3l2.3-2.9l0,0l3.6-4.6l0.1-0.2c21.7,4.3,105.8,13.1,159.4,18.2l2.9,0.3l29.9,86.6
	L429.4,768.6z"/>
<line class="st2" x1="426.7" y1="777.1" x2="427.4" y2="777.4"/>
<polygon class="st0" points="274.3,459.1 271.1,461 267.3,454.7 "/>
<polygon class="st0" points="258.9,496.8 252.9,506 252.8,506 252.4,497.1 "/>
<path class="st0" d="M267.3,454.7l3.8,6.3l3.2-1.9l0,0L254.9,497l-2.5,0.1l0.4,8.9h0.2h-7.8L169,634.1c-0.6-0.1,1.4,2.8,0.9,2.7
	c-0.9-0.2-2.1-0.3-1.9,0.5c0,0-0.8,1.6-0.8,1.6c0.3,1.2-1.2-1-2-0.1l-2.3,2.9l-7.1-5.3l5.9-7.5l104.8-175.6"/>
<g @click="mostarIntervencao(40)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(40)">
	<circle class="st3" cx="831.4" cy="515.9" r="14.5"/>
	<circle class="st4" cx="831.4" cy="515.9" r="13"/>
	<circle class="st5" cx="831.4" cy="515.9" r="11.7"/>
	<path class="st6" d="M831.4,528.3c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C843.8,522.8,838.2,528.3,831.4,528.3z M831.4,504.8c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C842.4,509.8,837.5,504.8,831.4,504.8L831.4,504.8z"/>
	<g>
		<path class="st7" d="M830.7,511.8c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C830.9,511.8,830.8,511.8,830.7,511.8z"/>
		<path class="st7" d="M830.7,510.8c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C830.9,510.8,830.8,510.8,830.7,510.8z"/>
		<path class="st7" d="M823.7,521.8c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C823.9,521.9,823.8,521.8,823.7,521.8z"/>
		<path class="st7" d="M823.6,512.7c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C823.4,512.5,823.5,512.7,823.6,512.7z"/>
		<path class="st7" d="M823.7,512.8C823.7,512.8,823.6,512.8,823.7,512.8C823.6,512.7,823.6,512.7,823.7,512.8L823.7,512.8z"/>
		<path class="st7" d="M823.7,514.8C823.7,514.8,823.7,514.8,823.7,514.8c-0.1,0-0.1,0-0.1,0L823.7,514.8z"/>
		<path class="st7" d="M828.5,513.5c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5l0-0.1h0h-0.3
			l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C828.6,513.9,828.6,513.6,828.5,513.5C828.5,513.5,828.5,513.5,828.5,513.5z"/>
		<path class="st7" d="M828.5,515.6c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3l-0.1,0
			l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C828.7,515.9,828.7,515.7,828.5,515.6C828.5,515.6,828.5,515.6,828.5,515.6z"/>
		<path class="st7" d="M828.5,517.6c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5l0-0.1h-0.2h0
			c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0-0.4-0.1-0.5
			C828.6,517.6,828.5,517.6,828.5,517.6z"/>
		<path class="st7" d="M828,519.6C828,519.6,828,519.6,828,519.6c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5l0-0.1h-0.3h0l-0.1,0
			l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C828.3,519.5,828.1,519.5,828,519.6z"/>
		<path class="st7" d="M835.5,520.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			s-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C835.1,520.8,835.3,520.6,835.5,520.4z M830.3,521.8h-0.7v-1h0.7V521.8z M831,521.8v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4s-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7h-0.7
			v-10.4h2.4l2.2,12H831z"/>
	</g>
		</v-touch>
</g>
<g  @click="mostarIntervencao(8)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(8)">
	<circle class="st3" cx="693.3" cy="307.9" r="14.5"/>
	<circle class="st4" cx="693.3" cy="307.9" r="13"/>
	<circle class="st5" cx="693.3" cy="307.9" r="11.7"/>
	<path class="st6" d="M693.3,320.3c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C705.7,314.8,700.2,320.3,693.3,320.3z M693.3,296.8c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C704.4,301.8,699.4,296.8,693.3,296.8L693.3,296.8z"/>
	<g>
		<path class="st7" d="M692.6,303.8c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C692.8,303.8,692.7,303.8,692.6,303.8z"/>
		<path class="st7" d="M692.6,302.8c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C692.8,302.8,692.7,302.8,692.6,302.8z"/>
		<path class="st7" d="M685.6,313.8c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C685.8,313.9,685.7,313.8,685.6,313.8z"/>
		<path class="st7" d="M685.5,304.7c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C685.3,304.5,685.4,304.7,685.5,304.7z"/>
		<path class="st7" d="M685.6,304.8C685.6,304.8,685.6,304.8,685.6,304.8C685.5,304.7,685.5,304.7,685.6,304.8L685.6,304.8z"/>
		<path class="st7" d="M685.7,306.8C685.6,306.8,685.6,306.8,685.7,306.8c-0.1,0-0.1,0-0.1,0L685.7,306.8z"/>
		<path class="st7" d="M690.4,305.5c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C690.6,305.9,690.6,305.6,690.4,305.5C690.4,305.5,690.4,305.5,690.4,305.5z"/>
		<path class="st7" d="M690.4,307.6c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2s0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C690.7,307.9,690.6,307.7,690.4,307.6C690.5,307.6,690.4,307.6,690.4,307.6z"/>
		<path class="st7" d="M690.4,309.6c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C690.5,309.6,690.5,309.6,690.4,309.6z"/>
		<path class="st7" d="M689.9,311.6C689.9,311.6,689.9,311.6,689.9,311.6c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.3h0l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C690.3,311.5,690,311.5,689.9,311.6z"/>
		<path class="st7" d="M697.4,312.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3H697l-0.2-1C697.1,312.8,697.3,312.6,697.4,312.4z M692.3,313.8h-0.7v-1h0.7V313.8z M692.9,313.8v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7
			h-0.7v-10.4h2.4l2.2,12H692.9z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(14)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(14)">
	<circle class="st3" cx="592.2" cy="361.3" r="14.5"/>
	<circle class="st4" cx="592.2" cy="361.3" r="13"/>
	<circle class="st5" cx="592.2" cy="361.3" r="11.7"/>
	<path class="st6" d="M592.2,373.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C604.6,368.2,599.1,373.7,592.2,373.8z M592.2,350.3c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C603.3,355.2,598.3,350.3,592.2,350.3L592.2,350.3z"/>
	<g>
		<path class="st7" d="M591.5,357.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C591.7,357.3,591.6,357.2,591.5,357.2z"/>
		<path class="st7" d="M591.5,356.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C591.7,356.3,591.6,356.2,591.5,356.2z"/>
		<path class="st7" d="M584.5,367.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C584.7,367.3,584.6,367.3,584.5,367.3z"/>
		<path class="st7" d="M584.4,358.2c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C584.2,358,584.3,358.1,584.4,358.2z"/>
		<path class="st7" d="M584.5,358.2C584.5,358.2,584.5,358.2,584.5,358.2C584.4,358.2,584.4,358.2,584.5,358.2L584.5,358.2z"/>
		<path class="st7" d="M584.6,360.3C584.5,360.2,584.5,360.2,584.6,360.3c-0.1,0-0.1,0-0.1,0L584.6,360.3z"/>
		<path class="st7" d="M589.3,359c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C589.5,359.3,589.4,359.1,589.3,359C589.3,359,589.3,359,589.3,359z"/>
		<path class="st7" d="M589.3,361c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3l-0.1,0
			l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C589.6,361.4,589.5,361.1,589.3,361C589.4,361,589.3,361,589.3,361z"/>
		<path class="st7" d="M589.3,363c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C589.4,363,589.4,363,589.3,363z"/>
		<path class="st7" d="M588.8,365.1C588.8,365.1,588.8,365.1,588.8,365.1c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.3h0l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C589.2,364.9,588.9,364.9,588.8,365.1z"/>
		<path class="st7" d="M596.3,365.8c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C596,366.2,596.2,366,596.3,365.8z M591.2,367.3h-0.7v-1h0.7V367.3z M591.8,367.3v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4s-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7h-0.7
			v-10.4h2.4l2.2,12H591.8z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(13)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(13)">
	<circle class="st3" cx="636.3" cy="362.3" r="14.5"/>
	<circle class="st4" cx="636.3" cy="362.3" r="13"/>
	<circle class="st5" cx="636.3" cy="362.3" r="11.7"/>
	<path class="st6" d="M636.3,374.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C648.7,369.1,643.2,374.7,636.3,374.7z M636.3,351.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1c0,0,0,0,0,0
		C647.4,356.2,642.4,351.2,636.3,351.2L636.3,351.2z"/>
	<g>
		<path class="st7" d="M635.6,358.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C635.8,358.2,635.7,358.2,635.6,358.2z"/>
		<path class="st7" d="M635.6,357.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C635.8,357.2,635.7,357.2,635.6,357.2z"/>
		<path class="st7" d="M628.6,368.2c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C628.8,368.3,628.7,368.2,628.6,368.2z"/>
		<path class="st7" d="M628.5,359.1c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C628.4,358.9,628.4,359.1,628.5,359.1z"/>
		<path class="st7" d="M628.6,359.2C628.6,359.2,628.6,359.2,628.6,359.2C628.5,359.1,628.5,359.1,628.6,359.2L628.6,359.2z"/>
		<path class="st7" d="M628.7,361.2C628.7,361.2,628.6,361.2,628.7,361.2c-0.1,0-0.1,0-0.1,0L628.7,361.2z"/>
		<path class="st7" d="M633.4,359.9c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C633.6,360.3,633.6,360,633.4,359.9C633.4,359.9,633.4,359.9,633.4,359.9z"/>
		<path class="st7" d="M633.4,362c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C633.7,362.3,633.7,362.1,633.4,362C633.5,362,633.5,362,633.4,362z"/>
		<path class="st7" d="M633.4,364c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C633.5,364,633.5,364,633.4,364z"/>
		<path class="st7" d="M633,366C633,366,633,366,633,366c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h-0.3h0l-0.1,0
			l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C633.3,365.9,633.1,365.9,633,366z"/>
		<path class="st7" d="M640.4,366.8c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3H640l-0.2-1C640.1,367.2,640.3,367,640.4,366.8z M635.3,368.2h-0.7v-1h0.7V368.2z M636,368.2v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7
			h-0.7v-10.4h2.4l2.2,12H636z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(9)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(9)">
	<circle class="st3" cx="438.4" cy="475.8" r="14.5"/>
	<circle class="st4" cx="438.4" cy="475.8" r="13"/>
	<circle class="st5" cx="438.4" cy="475.8" r="11.7"/>
	<path class="st6" d="M438.4,488.2c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C450.8,482.6,445.2,488.2,438.4,488.2z M438.4,464.7c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C449.4,469.7,444.5,464.7,438.4,464.7L438.4,464.7z"/>
	<g>
		<path class="st7" d="M437.7,471.7c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C437.9,471.7,437.8,471.7,437.7,471.7z"/>
		<path class="st7" d="M437.7,470.7c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C437.9,470.7,437.8,470.7,437.7,470.7z"/>
		<path class="st7" d="M430.7,481.7c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C430.9,481.7,430.8,481.7,430.7,481.7z"/>
		<path class="st7" d="M430.6,472.6c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C430.4,472.4,430.5,472.6,430.6,472.6z"/>
		<path class="st7" d="M430.7,472.7C430.7,472.7,430.6,472.6,430.7,472.7C430.6,472.6,430.6,472.6,430.7,472.7L430.7,472.7z"/>
		<path class="st7" d="M430.7,474.7C430.7,474.7,430.7,474.7,430.7,474.7c-0.1,0-0.1,0-0.1,0L430.7,474.7z"/>
		<path class="st7" d="M435.5,473.4c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C435.7,473.7,435.6,473.5,435.5,473.4C435.5,473.4,435.5,473.4,435.5,473.4z"/>
		<path class="st7" d="M435.5,475.4c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8C435.8,475.8,435.7,475.6,435.5,475.4
			C435.5,475.5,435.5,475.4,435.5,475.4z"/>
		<path class="st7" d="M435.5,477.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C435.6,477.5,435.5,477.5,435.5,477.5z"/>
		<path class="st7" d="M435,479.5C435,479.5,435,479.5,435,479.5c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h-0.3h0
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C435.3,479.3,435.1,479.4,435,479.5z"/>
		<path class="st7" d="M442.5,480.3c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C442.1,480.6,442.4,480.5,442.5,480.3z M437.4,481.7h-0.7v-1h0.7V481.7z M438,481.7v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7
			h-0.7v-10.4h2.4l2.2,12H438z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(33)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(33)">
	<circle class="st3" cx="489.5" cy="615.7" r="14.5"/>
	<circle class="st4" cx="489.5" cy="615.7" r="13"/>
	<circle class="st5" cx="489.5" cy="615.7" r="11.7"/>
	<path class="st6" d="M489.5,628.1c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C501.9,622.5,496.4,628.1,489.5,628.1z M489.5,604.6c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C500.6,609.6,495.6,604.6,489.5,604.6L489.5,604.6z"/>
	<g>
		<path class="st7" d="M488.8,611.6c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C489,611.6,488.9,611.6,488.8,611.6z"/>
		<path class="st7" d="M488.8,610.6c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C489,610.6,488.9,610.6,488.8,610.6z"/>
		<path class="st7" d="M481.8,621.6c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C482,621.6,481.9,621.6,481.8,621.6z"/>
		<path class="st7" d="M481.7,612.5c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C481.6,612.3,481.6,612.5,481.7,612.5z"/>
		<path class="st7" d="M481.8,612.6C481.8,612.6,481.8,612.6,481.8,612.6C481.7,612.5,481.7,612.5,481.8,612.6L481.8,612.6z"/>
		<path class="st7" d="M481.9,614.6C481.9,614.6,481.8,614.6,481.9,614.6c-0.1,0-0.1,0-0.1,0L481.9,614.6z"/>
		<path class="st7" d="M486.6,613.3c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C486.8,613.6,486.8,613.4,486.6,613.3C486.6,613.3,486.6,613.3,486.6,613.3z"/>
		<path class="st7" d="M486.6,615.3c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8C486.9,615.7,486.9,615.5,486.6,615.3
			C486.7,615.4,486.6,615.4,486.6,615.3z"/>
		<path class="st7" d="M486.6,617.4c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C486.7,617.4,486.7,617.4,486.6,617.4z"/>
		<path class="st7" d="M486.2,619.4C486.2,619.4,486.1,619.4,486.2,619.4c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.3h0l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C486.5,619.2,486.3,619.3,486.2,619.4z"/>
		<path class="st7" d="M493.6,620.2c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C493.3,620.6,493.5,620.4,493.6,620.2z M488.5,621.6h-0.7v-1h0.7V621.6z M489.2,621.6v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7
			h-0.7v-10.4h2.4l2.2,12H489.2z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(34)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(34)">
	<circle class="st3" cx="488.9" cy="646.3" r="14.5"/>
	<circle class="st4" cx="488.9" cy="646.3" r="13"/>
	<circle class="st5" cx="488.9" cy="646.3" r="11.7"/>
	<path class="st6" d="M489,658.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C501.4,653.1,495.8,658.7,489,658.7z M489,635.2c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C500,640.1,495.1,635.2,489,635.2L489,635.2z"/>
	<g>
		<path class="st7" d="M488.3,642.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C488.5,642.2,488.4,642.2,488.3,642.2z"/>
		<path class="st7" d="M488.3,641.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C488.5,641.2,488.4,641.2,488.3,641.2z"/>
		<path class="st7" d="M481.3,652.2c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C481.4,652.2,481.4,652.2,481.3,652.2z"/>
		<path class="st7" d="M481.2,643.1c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C481,642.9,481.1,643,481.2,643.1z"/>
		<path class="st7" d="M481.3,643.2C481.2,643.1,481.2,643.1,481.3,643.2C481.2,643.1,481.2,643.1,481.3,643.2L481.3,643.2z"/>
		<path class="st7" d="M481.3,645.2C481.3,645.2,481.3,645.2,481.3,645.2c-0.1,0-0.1,0-0.1,0L481.3,645.2z"/>
		<path class="st7" d="M486.1,643.9c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C486.2,644.2,486.2,644,486.1,643.9C486.1,643.9,486.1,643.9,486.1,643.9z"/>
		<path class="st7" d="M486.1,645.9c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3l-0.1,0
			l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C486.3,646.3,486.3,646.1,486.1,645.9C486.1,645.9,486.1,645.9,486.1,645.9z"/>
		<path class="st7" d="M486.1,647.9c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C486.2,648,486.1,647.9,486.1,647.9z"/>
		<path class="st7" d="M485.6,650C485.6,650,485.6,650,485.6,650c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h-0.3h0
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C485.9,649.8,485.7,649.8,485.6,650z"/>
		<path class="st7" d="M493.1,650.7c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C492.7,651.1,492.9,651,493.1,650.7z M487.9,652.2h-0.7v-1h0.7V652.2z M488.6,652.2v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4s-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7h-0.7
			v-10.4h2.4l2.2,12H488.6z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(24)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(24)">
	<circle class="st3" cx="748.2" cy="623.2" r="14.5"/>
	<circle class="st4" cx="748.2" cy="623.2" r="13"/>
	<circle class="st5" cx="748.2" cy="623.2" r="11.7"/>
	<path class="st6" d="M748.2,635.6c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C760.6,630,755.1,635.6,748.2,635.6z M748.2,612.1c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C759.3,617.1,754.3,612.1,748.2,612.1L748.2,612.1z"/>
	<g>
		<path class="st7" d="M747.5,619.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C747.7,619.1,747.6,619.1,747.5,619.1z"/>
		<path class="st7" d="M747.5,618.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C747.7,618.1,747.6,618.1,747.5,618.1z"/>
		<path class="st7" d="M740.5,629.1c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C740.7,629.1,740.6,629.1,740.5,629.1z"/>
		<path class="st7" d="M740.4,620c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C740.2,619.8,740.3,620,740.4,620z"/>
		<path class="st7" d="M740.5,620.1C740.5,620.1,740.5,620.1,740.5,620.1C740.4,620,740.4,620,740.5,620.1L740.5,620.1z"/>
		<path class="st7" d="M740.6,622.1C740.5,622.1,740.5,622.1,740.6,622.1c-0.1,0-0.1,0-0.1,0L740.6,622.1z"/>
		<path class="st7" d="M745.3,620.8c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C745.5,621.1,745.5,620.9,745.3,620.8C745.3,620.8,745.3,620.8,745.3,620.8z"/>
		<path class="st7" d="M745.3,622.8c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2s0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C745.6,623.2,745.5,623,745.3,622.8C745.4,622.9,745.3,622.9,745.3,622.8z"/>
		<path class="st7" d="M745.3,624.9c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C745.4,624.9,745.4,624.9,745.3,624.9z"/>
		<path class="st7" d="M744.8,626.9C744.8,626.9,744.8,626.9,744.8,626.9c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.3h0l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C745.2,626.7,744.9,626.8,744.8,626.9z"/>
		<path class="st7" d="M752.3,627.7c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C752,628.1,752.2,627.9,752.3,627.7z M747.2,629.1h-0.7v-1h0.7V629.1z M747.8,629.1v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7
			h-0.7v-10.4h2.4l2.2,12H747.8z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(26)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(26)">
	<circle class="st3" cx="783.2" cy="588.8" r="14.5"/>
	<circle class="st4" cx="783.2" cy="588.8" r="13"/>
	<circle class="st5" cx="783.2" cy="588.8" r="11.7"/>
	<path class="st6" d="M783.3,601.2c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C795.7,595.6,790.1,601.2,783.3,601.2z M783.3,577.7c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1s11.1-5,11.1-11.1c0,0,0,0,0,0
		C794.3,582.6,789.4,577.7,783.3,577.7L783.3,577.7z"/>
	<g>
		<path class="st7" d="M782.6,584.7c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C782.8,584.7,782.7,584.7,782.6,584.7z"/>
		<path class="st7" d="M782.6,583.7c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C782.8,583.7,782.7,583.7,782.6,583.7z"/>
		<path class="st7" d="M775.6,594.7c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C775.7,594.7,775.7,594.7,775.6,594.7z"/>
		<path class="st7" d="M775.5,585.6c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C775.3,585.4,775.4,585.5,775.5,585.6z"/>
		<path class="st7" d="M775.6,585.7C775.5,585.6,775.5,585.6,775.6,585.7C775.5,585.6,775.5,585.6,775.6,585.7L775.6,585.7z"/>
		<path class="st7" d="M775.6,587.7C775.6,587.7,775.6,587.7,775.6,587.7c-0.1,0-0.1,0-0.1,0L775.6,587.7z"/>
		<path class="st7" d="M780.4,586.4c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C780.5,586.7,780.5,586.5,780.4,586.4C780.4,586.4,780.4,586.4,780.4,586.4z"/>
		<path class="st7" d="M780.4,588.4c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3l-0.1,0
			l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2s0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C780.6,588.8,780.6,588.6,780.4,588.4C780.4,588.4,780.4,588.4,780.4,588.4z"/>
		<path class="st7" d="M780.4,590.4c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C780.5,590.5,780.4,590.4,780.4,590.4z"/>
		<path class="st7" d="M779.9,592.5C779.9,592.5,779.9,592.5,779.9,592.5c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.3h0l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C780.2,592.3,780,592.3,779.9,592.5z"/>
		<path class="st7" d="M787.4,593.3c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3H787l-0.2-1C787,593.6,787.2,593.5,787.4,593.3z M782.2,594.7h-0.7v-1h0.7V594.7z M782.9,594.7v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4s-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7h-0.7
			v-10.4h2.4l2.2,12H782.9z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(42)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(27)">
	<circle class="st3" cx="759.3" cy="574.3" r="14.5"/>
	<circle class="st4" cx="759.3" cy="574.3" r="13"/>
	<circle class="st5" cx="759.3" cy="574.3" r="11.7"/>
	<path class="st6" d="M759.3,586.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4s12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C771.7,581.1,766.1,586.7,759.3,586.7z M759.3,563.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1c0,0,0,0,0,0
		C770.3,568.1,765.4,563.2,759.3,563.2L759.3,563.2z"/>
	<g>
		<path class="st7" d="M758.6,570.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C758.8,570.2,758.7,570.2,758.6,570.2z"/>
		<path class="st7" d="M758.6,569.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C758.8,569.2,758.7,569.2,758.6,569.2z"/>
		<path class="st7" d="M751.6,580.2c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C751.8,580.2,751.7,580.2,751.6,580.2z"/>
		<path class="st7" d="M751.5,571.1c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5s-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4
			c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2
			C751.3,570.9,751.4,571,751.5,571.1z"/>
		<path class="st7" d="M751.6,571.2C751.6,571.1,751.5,571.1,751.6,571.2C751.5,571.1,751.5,571.1,751.6,571.2L751.6,571.2z"/>
		<path class="st7" d="M751.6,573.2C751.6,573.2,751.6,573.2,751.6,573.2c-0.1,0-0.1,0-0.1,0L751.6,573.2z"/>
		<path class="st7" d="M756.4,571.9c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C756.6,572.2,756.5,572,756.4,571.9C756.4,571.9,756.4,571.9,756.4,571.9z"/>
		<path class="st7" d="M756.4,573.9c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C756.7,574.3,756.6,574.1,756.4,573.9C756.4,573.9,756.4,573.9,756.4,573.9z"/>
		<path class="st7" d="M756.4,575.9c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C756.5,576,756.4,575.9,756.4,575.9z"/>
		<path class="st7" d="M755.9,578C755.9,578,755.9,578,755.9,578c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h-0.3h0
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C756.2,577.8,756,577.8,755.9,578z"/>
		<path class="st7" d="M763.4,578.7c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3H763l-0.2-1C763,579.1,763.2,579,763.4,578.7z M758.2,580.2h-0.7v-1h0.7V580.2z M758.9,580.2v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7
			h-0.7v-10.4h2.4l2.2,12H758.9z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(10)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(10)">
	<circle class="st3" cx="673.6" cy="574.2" r="14.5"/>
	<circle class="st4" cx="673.6" cy="574.2" r="13"/>
	<circle class="st5" cx="673.6" cy="574.2" r="11.7"/>
	<path class="st6" d="M673.6,586.6c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C686,581,680.5,586.6,673.6,586.6z M673.6,563.1c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1s11.1-5,11.1-11.1c0,0,0,0,0,0
		C684.7,568,679.7,563.1,673.6,563.1L673.6,563.1z"/>
	<g>
		<path class="st7" d="M672.9,570.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C673.1,570.1,673,570.1,672.9,570.1z"/>
		<path class="st7" d="M672.9,569.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C673.1,569.1,673,569.1,672.9,569.1z"/>
		<path class="st7" d="M665.9,580.1c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C666.1,580.1,666,580.1,665.9,580.1z"/>
		<path class="st7" d="M665.8,571c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C665.7,570.8,665.7,570.9,665.8,571z"/>
		<path class="st7" d="M665.9,571.1C665.9,571.1,665.9,571,665.9,571.1C665.8,571,665.8,571,665.9,571.1L665.9,571.1z"/>
		<path class="st7" d="M666,573.1C666,573.1,665.9,573.1,666,573.1c-0.1,0-0.1,0-0.1,0L666,573.1z"/>
		<path class="st7" d="M670.7,571.8c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C670.9,572.1,670.9,571.9,670.7,571.8C670.7,571.8,670.7,571.8,670.7,571.8z"/>
		<path class="st7" d="M670.7,573.8c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C671,574.2,671,574,670.7,573.8C670.8,573.8,670.7,573.8,670.7,573.8z"/>
		<path class="st7" d="M670.7,575.9c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C670.8,575.9,670.8,575.9,670.7,575.9z"/>
		<path class="st7" d="M670.2,577.9C670.2,577.9,670.2,577.9,670.2,577.9c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.3h0l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C670.6,577.7,670.4,577.8,670.2,577.9z"/>
		<path class="st7" d="M677.7,578.7c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3H667c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.2-0.3-0.3-0.3
			h-3.7l-0.2-1C677.4,579,677.6,578.9,677.7,578.7z M672.6,580.1h-0.7v-1h0.7V580.1z M673.3,580.1v-1h2c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7h-0.7v-10.4h2.4l2.2,12
			H673.3z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(12)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(12)">
	<circle class="st3" cx="704.4" cy="566.8" r="14.5"/>
	<circle class="st4" cx="704.4" cy="566.8" r="13"/>
	<circle class="st5" cx="704.4" cy="566.8" r="11.7"/>
	<path class="st6" d="M704.4,579.2c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C716.8,573.6,711.2,579.2,704.4,579.2z M704.4,555.7c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C715.4,560.7,710.5,555.7,704.4,555.7L704.4,555.7z"/>
	<g>
		<path class="st7" d="M703.7,562.7c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C703.9,562.7,703.8,562.7,703.7,562.7z"/>
		<path class="st7" d="M703.7,561.7c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C703.9,561.7,703.8,561.7,703.7,561.7z"/>
		<path class="st7" d="M696.7,572.7c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C696.9,572.7,696.8,572.7,696.7,572.7z"/>
		<path class="st7" d="M696.6,563.6c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5s-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			s-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4
			c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2
			C696.4,563.4,696.5,563.6,696.6,563.6z"/>
		<path class="st7" d="M696.7,563.7C696.7,563.7,696.6,563.7,696.7,563.7C696.6,563.6,696.6,563.6,696.7,563.7L696.7,563.7z"/>
		<path class="st7" d="M696.7,565.7C696.7,565.7,696.7,565.7,696.7,565.7c-0.1,0-0.1,0-0.1,0L696.7,565.7z"/>
		<path class="st7" d="M701.5,564.4c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C701.7,564.7,701.6,564.5,701.5,564.4C701.5,564.4,701.5,564.4,701.5,564.4z"/>
		<path class="st7" d="M701.5,566.4c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C701.8,566.8,701.7,566.6,701.5,566.4C701.5,566.5,701.5,566.4,701.5,566.4z"/>
		<path class="st7" d="M701.5,568.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C701.6,568.5,701.5,568.5,701.5,568.5z"/>
		<path class="st7" d="M701,570.5C701,570.5,701,570.5,701,570.5c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h-0.3h0
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C701.3,570.3,701.1,570.4,701,570.5z"/>
		<path class="st7" d="M708.5,571.3c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C708.1,571.6,708.3,571.5,708.5,571.3z M703.3,572.7h-0.7v-1h0.7V572.7z M704,572.7v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7
			h-0.7v-10.4h2.4l2.2,12H704z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(11)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(11)">
	<circle class="st3" cx="733.1" cy="553.8" r="14.5"/>
	<circle class="st4" cx="733.1" cy="553.8" r="13"/>
	<circle class="st5" cx="733.1" cy="553.8" r="11.7"/>
	<path class="st6" d="M733.1,566.2c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C745.5,560.6,740,566.2,733.1,566.2z M733.1,542.7c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C744.2,547.6,739.2,542.7,733.1,542.7L733.1,542.7z"/>
	<g>
		<path class="st7" d="M732.5,549.7c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C732.6,549.7,732.5,549.7,732.5,549.7z"/>
		<path class="st7" d="M732.5,548.7c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C732.6,548.7,732.5,548.7,732.5,548.7z"/>
		<path class="st7" d="M725.4,559.7c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C725.6,559.7,725.5,559.7,725.4,559.7z"/>
		<path class="st7" d="M725.4,550.6c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C725.2,550.4,725.2,550.5,725.4,550.6z"/>
		<path class="st7" d="M725.5,550.7C725.4,550.7,725.4,550.6,725.5,550.7C725.4,550.6,725.4,550.6,725.5,550.7L725.5,550.7z"/>
		<path class="st7" d="M725.5,552.7C725.5,552.7,725.5,552.7,725.5,552.7c-0.1,0-0.1,0-0.1,0L725.5,552.7z"/>
		<path class="st7" d="M730.2,551.4c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C730.4,551.7,730.4,551.5,730.2,551.4C730.2,551.4,730.2,551.4,730.2,551.4z"/>
		<path class="st7" d="M730.2,553.4c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C730.5,553.8,730.5,553.6,730.2,553.4C730.3,553.4,730.3,553.4,730.2,553.4z"/>
		<path class="st7" d="M730.2,555.4c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C730.4,555.5,730.3,555.4,730.2,555.4z"/>
		<path class="st7" d="M729.8,557.5C729.8,557.5,729.8,557.5,729.8,557.5c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.3h0l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C730.1,557.3,729.9,557.4,729.8,557.5z"/>
		<path class="st7" d="M737.3,558.3c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0H739l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C736.9,558.6,737.1,558.5,737.3,558.3z M732.1,559.7h-0.7v-1h0.7V559.7z M732.8,559.7v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7
			h-0.7v-10.4h2.4l2.2,12H732.8z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(7)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(7)">
	<circle class="st3" cx="748.8" cy="527" r="14.5"/>
	<circle class="st4" cx="748.8" cy="527" r="13"/>
	<circle class="st5" cx="748.8" cy="527" r="11.7"/>
	<path class="st6" d="M748.8,539.4c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C761.2,533.8,755.7,539.4,748.8,539.4z M748.8,515.9c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1s11.1-5,11.1-11.1c0,0,0,0,0,0
		C759.9,520.9,754.9,515.9,748.8,515.9L748.8,515.9z"/>
	<g>
		<path class="st7" d="M748.1,522.9c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C748.3,522.9,748.2,522.9,748.1,522.9z"/>
		<path class="st7" d="M748.1,521.9c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C748.3,521.9,748.2,521.9,748.1,521.9z"/>
		<path class="st7" d="M741.1,532.9c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C741.3,532.9,741.2,532.9,741.1,532.9z"/>
		<path class="st7" d="M741.1,523.8c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C740.9,523.6,740.9,523.7,741.1,523.8z"/>
		<path class="st7" d="M741.1,523.9C741.1,523.9,741.1,523.8,741.1,523.9C741,523.8,741,523.8,741.1,523.9L741.1,523.9z"/>
		<path class="st7" d="M741.2,525.9C741.2,525.9,741.1,525.9,741.2,525.9c-0.1,0-0.1,0-0.1,0L741.2,525.9z"/>
		<path class="st7" d="M745.9,524.6c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C746.1,524.9,746.1,524.7,745.9,524.6C745.9,524.6,745.9,524.6,745.9,524.6z"/>
		<path class="st7" d="M745.9,526.6c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3l-0.1,0
			l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2s0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C746.2,527,746.2,526.8,745.9,526.6C746,526.7,746,526.6,745.9,526.6z"/>
		<path class="st7" d="M745.9,528.7c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			H744h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C746,528.7,746,528.7,745.9,528.7z"/>
		<path class="st7" d="M745.5,530.7C745.5,530.7,745.5,530.7,745.5,530.7c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			H744h0l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C745.8,530.5,745.6,530.6,745.5,530.7z"/>
		<path class="st7" d="M753,531.5c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0V533h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.2-0.3-0.3-0.3
			h-3.7l-0.2-1C752.6,531.8,752.8,531.7,753,531.5z M747.8,532.9h-0.7v-1h0.7V532.9z M748.5,532.9v-1h2c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4s-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7h-0.7v-10.4h2.4l2.2,12H748.5
			z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(6)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(6)">
	<circle class="st3" cx="740.3" cy="497.5" r="14.5"/>
	<circle class="st4" cx="740.3" cy="497.5" r="13"/>
	<circle class="st5" cx="740.3" cy="497.5" r="11.7"/>
	<path class="st6" d="M740.3,509.9c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C752.8,504.3,747.2,509.9,740.3,509.9z M740.3,486.4c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C751.4,491.4,746.5,486.4,740.3,486.4L740.3,486.4z"/>
	<g>
		<path class="st7" d="M739.7,493.4c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C739.8,493.4,739.8,493.4,739.7,493.4z"/>
		<path class="st7" d="M739.7,492.4c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C739.8,492.4,739.8,492.4,739.7,492.4z"/>
		<path class="st7" d="M732.7,503.4c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C732.8,503.4,732.7,503.4,732.7,503.4z"/>
		<path class="st7" d="M732.6,494.3c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C732.4,494.1,732.5,494.3,732.6,494.3z"/>
		<path class="st7" d="M732.7,494.4C732.6,494.4,732.6,494.4,732.7,494.4C732.6,494.3,732.6,494.3,732.7,494.4L732.7,494.4z"/>
		<path class="st7" d="M732.7,496.4C732.7,496.4,732.7,496.4,732.7,496.4c-0.1,0-0.1,0-0.1,0L732.7,496.4z"/>
		<path class="st7" d="M737.4,495.1c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C737.6,495.4,737.6,495.2,737.4,495.1C737.5,495.1,737.5,495.1,737.4,495.1z"/>
		<path class="st7" d="M737.4,497.1c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C737.7,497.5,737.7,497.3,737.4,497.1C737.5,497.2,737.5,497.1,737.4,497.1z"/>
		<path class="st7" d="M737.4,499.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C737.6,499.2,737.5,499.2,737.4,499.2z"/>
		<path class="st7" d="M737,501.2C737,501.2,737,501.2,737,501.2c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h-0.3h0
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C737.3,501,737.1,501.1,737,501.2z"/>
		<path class="st7" d="M744.5,502c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C744.1,502.3,744.3,502.2,744.5,502z M739.3,503.4h-0.7v-1h0.7V503.4z M740,503.4v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7
			h-0.7v-10.4h2.4l2.2,12H740z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(41)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(6)">
	<circle class="st3" cx="454.4" cy="678.8" r="14.5"/>
	<circle class="st4" cx="454.4" cy="678.8" r="13"/>
	<circle class="st5" cx="454.4" cy="678.8" r="11.7"/>
	<path class="st6" d="M454.4,691.2c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4s12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C466.8,685.7,461.3,691.2,454.4,691.2z M454.4,667.7c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C465.5,672.7,460.5,667.7,454.4,667.7L454.4,667.7z"/>
	<g>
		<path class="st7" d="M453.7,674.7c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C453.9,674.7,453.8,674.7,453.7,674.7z"/>
		<path class="st7" d="M453.7,673.7c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C453.9,673.7,453.8,673.7,453.7,673.7z"/>
		<path class="st7" d="M446.7,684.7c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C446.9,684.8,446.8,684.7,446.7,684.7z"/>
		<path class="st7" d="M446.6,675.6c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C446.5,675.4,446.5,675.6,446.6,675.6z"/>
		<path class="st7" d="M446.7,675.7C446.7,675.7,446.7,675.7,446.7,675.7C446.6,675.6,446.6,675.6,446.7,675.7L446.7,675.7z"/>
		<path class="st7" d="M446.8,677.7C446.7,677.7,446.7,677.7,446.8,677.7c-0.1,0-0.1,0-0.1,0L446.8,677.7z"/>
		<path class="st7" d="M451.5,676.4c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C451.7,676.8,451.7,676.5,451.5,676.4C451.5,676.4,451.5,676.4,451.5,676.4z"/>
		<path class="st7" d="M451.5,678.5c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C451.8,678.8,451.8,678.6,451.5,678.5C451.6,678.5,451.5,678.5,451.5,678.5z"/>
		<path class="st7" d="M451.5,680.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C451.6,680.5,451.6,680.5,451.5,680.5z"/>
		<path class="st7" d="M451,682.5C451,682.5,451,682.5,451,682.5c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h-0.3h0
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C451.4,682.4,451.2,682.4,451,682.5z"/>
		<path class="st7" d="M458.5,683.3c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C458.2,683.7,458.4,683.5,458.5,683.3z M453.4,684.7h-0.7v-1h0.7V684.7z M454.1,684.7v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4s-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7h-0.7
			v-10.4h2.4l2.2,12H454.1z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(2)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(2)">
	<circle class="st3" cx="657.2" cy="319" r="14.5"/>
	<circle class="st4" cx="657.2" cy="319" r="13"/>
	<circle class="st5" cx="657.2" cy="319" r="11.7"/>
	<path class="st6" d="M657.2,331.4c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C669.6,325.8,664.1,331.4,657.2,331.4z M657.2,307.9c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C668.3,312.9,663.3,307.9,657.2,307.9L657.2,307.9z"/>
	<path class="st7" d="M664.8,318.6h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C665,318.7,664.9,318.6,664.8,318.6
		C664.8,318.6,664.8,318.6,664.8,318.6z M657.7,314.7h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8
		l0,0h-0.1h-0.1l-1.7-0.3h-0.9L657.7,314.7z M651.3,324h-1.4v-4.9h1.4V324z M656.6,313.9h0.6v0.3h-0.6V313.9z M656.6,314.7h0.6v0.6
		h-0.6V314.7z M656.6,315.8h0.6v1.7h-0.6V315.8z M655.3,315.3L655.3,315.3l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6
		c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L655.3,315.3z M655.5,318h2.8v1.1h-2.8V318z M651.8,320.1h1.8v2.8h-1.8
		V320.1z M659.7,323.5h-5.5v-3.9h5.5V323.5z M662.7,322.9h-2.5v-2.8h2.5V322.9z M664.6,324h-1.4v-4.9h1.4L664.6,324z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(3)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(3)">
	<circle class="st3" cx="745.6" cy="406.4" r="14.5"/>
	<circle class="st4" cx="745.6" cy="406.4" r="13"/>
	<circle class="st5" cx="745.6" cy="406.4" r="11.7"/>
	<path class="st6" d="M745.6,418.8c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C758.1,413.2,752.5,418.8,745.6,418.8z M745.6,395.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C756.7,400.3,751.7,395.3,745.6,395.3L745.6,395.3z"/>
	<path class="st7" d="M753.2,406h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C753.4,406.1,753.3,406,753.2,406
		C753.2,406,753.2,406,753.2,406z M746.1,402.1h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0
		h-0.1h-0.1l-1.7-0.3h-0.9V402.1z M739.7,411.4h-1.4v-4.9h1.4V411.4z M745,401.3h0.6v0.3H745V401.3z M745,402.1h0.6v0.6H745V402.1z
		 M745,403.2h0.6v1.7H745V403.2z M743.7,402.7L743.7,402.7l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6
		c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L743.7,402.7z M743.9,405.4h2.8v1.1h-2.8V405.4z M740.2,407.5h1.8v2.8h-1.8V407.5z M748.1,410.9
		h-5.5V407h5.5V410.9z M751.1,410.3h-2.5v-2.8h2.5V410.3z M753,411.4h-1.4v-4.9h1.4L753,411.4z"/>
		</v-touch>
</g>
<g @click="mostarIntervencao(5)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(5)">
	<circle class="st3" cx="686.8" cy="443.3" r="14.5"/>
	<circle class="st4" cx="686.8" cy="443.3" r="13"/>
	<circle class="st5" cx="686.8" cy="443.3" r="11.7"/>
	<path class="st6" d="M686.8,455.8c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C699.2,450.2,693.6,455.8,686.8,455.8z M686.8,432.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C697.9,437.2,692.9,432.3,686.8,432.3L686.8,432.3z"/>
	<path class="st7" d="M694.3,443h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3h-0.8V438c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C694.6,443.1,694.5,442.9,694.3,443
		C694.3,443,694.3,443,694.3,443z M687.2,439.1h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0
		h-0.1h-0.1l-1.7-0.3h-0.9V439.1z M680.9,448.4h-1.4v-4.9h1.4V448.4z M686.2,438.3h0.6v0.3h-0.6V438.3z M686.2,439.1h0.6v0.6h-0.6
		V439.1z M686.2,440.2h0.6v1.7h-0.6V440.2z M684.8,439.7L684.8,439.7l-1.7,0.3H683c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6
		c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L684.8,439.7z M685.1,442.3h2.8v1.1h-2.8V442.3z M681.4,444.5h1.8v2.8h-1.8V444.5z M689.2,447.8
		h-5.5V444h5.5V447.8z M692.2,447.3h-2.5v-2.8h2.5V447.3z M694.1,448.4h-1.4v-4.9h1.4L694.1,448.4z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(4)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(4)">
	<circle class="st3" cx="477.8" cy="464.7" r="14.5"/>
	<circle class="st4" cx="477.8" cy="464.7" r="13"/>
	<circle class="st5" cx="477.8" cy="464.7" r="11.7"/>
	<path class="st6" d="M477.8,477.1c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C490.2,471.6,484.6,477.1,477.8,477.1z M477.8,453.6c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C488.8,458.6,483.9,453.6,477.8,453.6L477.8,453.6z"/>
	<path class="st7" d="M485.3,464.3h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		L479,460h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C485.6,464.4,485.4,464.3,485.3,464.3
		C485.3,464.3,485.3,464.3,485.3,464.3z M478.2,460.5h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8
		l0,0h-0.1h-0.1l-1.7-0.3h-0.9L478.2,460.5z M471.8,469.7h-1.4v-4.9h1.4V469.7z M477.1,459.6h0.6v0.3h-0.6V459.6z M477.1,460.4h0.6
		v0.6h-0.6V460.4z M477.1,461.5h0.6v1.7h-0.6V461.5z M475.8,461L475.8,461l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6
		c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L475.8,461z M476,463.7h2.8v1.1H476V463.7z M472.3,465.9h1.8v2.8h-1.8
		V465.9z M480.2,469.2h-5.5v-3.9h5.5V469.2z M483.2,468.6h-2.5v-2.8h2.5V468.6z M485.1,469.7h-1.4v-4.9h1.4L485.1,469.7z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(1)">
	 <v-touch tag="a" v-on:tap="mostarIntervencao(1)">
	<circle class="st3" cx="427.4" cy="437.8" r="14.5"/>
	<circle class="st4" cx="427.4" cy="437.8" r="13"/>
	<circle class="st5" cx="427.4" cy="437.8" r="11.7"/>
	<path class="st6" d="M427.4,450.2c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C439.8,444.6,434.2,450.2,427.4,450.2z M427.4,426.7c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C438.5,431.7,433.5,426.7,427.4,426.7L427.4,426.7z"/>
	<path class="st7" d="M434.9,437.4H433c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3H422v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C435.2,437.5,435.1,437.4,434.9,437.4
		C434.9,437.4,434.9,437.4,434.9,437.4z M427.8,433.6h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5s-0.2,0.7-0.5,0.8l0,0h-0.1
		h-0.1l-1.7-0.3h-0.9L427.8,433.6z M421.5,442.8h-1.4v-4.9h1.4V442.8z M426.8,432.7h0.6v0.3h-0.6V432.7z M426.8,433.5h0.6v0.6h-0.6
		V433.5z M426.8,434.6h0.6v1.7h-0.6V434.6z M425.4,434.1L425.4,434.1l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6
		c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L425.4,434.1z M425.7,436.8h2.8v1.1h-2.8V436.8z M422,438.9h1.8v2.8H422V438.9z M429.8,442.3
		h-5.5v-3.9h5.5V442.3z M432.8,441.7h-2.5V439h2.5V441.7z M434.7,442.8h-1.4v-4.9h1.4L434.7,442.8z"/>
	 </v-touch>
</g>
<g @click="mostarIntervencao(36)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(36)">
	<circle class="st3" cx="452.7" cy="573.4" r="14.5"/>
	<circle class="st4" cx="452.7" cy="573.4" r="13"/>
	<circle class="st5" cx="452.7" cy="573.4" r="11.7"/>
	<path class="st6" d="M452.7,585.9c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C465.1,580.3,459.6,585.9,452.7,585.9z M452.7,562.4c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C463.8,567.3,458.8,562.4,452.7,562.4L452.7,562.4z"/>
	<path class="st7" d="M460.3,573.1h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C460.5,573.2,460.4,573.1,460.3,573.1
		C460.3,573.1,460.3,573.1,460.3,573.1z M453.2,569.2h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5s-0.2,0.7-0.5,0.8l0,0h-0.1
		h-0.1l-1.7-0.3h-0.9L453.2,569.2z M446.8,578.5h-1.4v-4.9h1.4V578.5z M452.1,568.4h0.6v0.3h-0.6V568.4z M452.1,569.2h0.6v0.6h-0.6
		V569.2z M452.1,570.3h0.6v1.7h-0.6V570.3z M450.7,569.8L450.7,569.8l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6
		c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L450.7,569.8z M451,572.5h2.8v1.1H451V572.5z M447.3,574.6h1.8v2.8h-1.8V574.6z M455.1,578h-5.5
		v-3.9h5.5V578z M458.1,577.4h-2.5v-2.8h2.5V577.4z M460,578.5h-1.4v-4.9h1.4L460,578.5z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(29)">
		<v-touch tag="a" v-on:tap="mostarIntervencao(29)">
	<circle class="st3" cx="347.4" cy="523.2" r="14.5"/>
	<circle class="st4" cx="347.4" cy="523.2" r="13"/>
	<circle class="st5" cx="347.4" cy="523.2" r="11.7"/>
	<path class="st6" d="M347.4,535.6c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C359.8,530.1,354.3,535.6,347.4,535.6z M347.4,512.1c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C358.5,517.1,353.5,512.1,347.4,512.1L347.4,512.1z"/>
	<path class="st7" d="M355,522.8H353c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1V522
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3H342V523c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C355.2,522.9,355.1,522.8,355,522.8
		C355,522.8,355,522.8,355,522.8z M347.9,519h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5s-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1
		l-1.7-0.3h-0.9L347.9,519z M341.5,528.2h-1.4v-4.9h1.4V528.2z M346.8,518.1h0.6v0.3h-0.6V518.1z M346.8,518.9h0.6v0.6h-0.6V518.9z
		 M346.8,520h0.6v1.7h-0.6V520z M345.4,519.5L345.4,519.5l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6
		c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L345.4,519.5z M345.7,522.2h2.8v1.1h-2.8V522.2z M342,524.4h1.8v2.8H342V524.4z M349.8,527.7
		h-5.5v-3.9h5.5V527.7z M352.8,527.1h-2.5v-2.8h2.5V527.1z M354.7,528.2h-1.4v-4.9h1.4L354.7,528.2z"/>
		</v-touch>
</g>
<g @click="mostarIntervencao(30)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(30)">
	<circle class="st3" cx="482.6" cy="672.7" r="14.5"/>
	<circle class="st4" cx="482.6" cy="672.7" r="13"/>
	<circle class="st5" cx="482.6" cy="672.7" r="11.7"/>
	<path class="st6" d="M482.6,685.1c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C495,679.6,489.5,685.1,482.6,685.1z M482.6,661.6c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C493.7,666.6,488.7,661.6,482.6,661.6L482.6,661.6z"/>
	<path class="st7" d="M490.1,672.3h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0H483v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3H483v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0H475c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C490.4,672.4,490.3,672.3,490.1,672.3
		C490.2,672.3,490.1,672.3,490.1,672.3z M483.1,668.5h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8
		l0,0h-0.1h-0.1l-1.7-0.3h-0.9L483.1,668.5z M476.7,677.7h-1.4v-4.9h1.4V677.7z M482,667.6h0.6v0.3H482V667.6z M482,668.4h0.6v0.6
		H482V668.4z M482,669.5h0.6v1.7H482V669.5z M480.6,669L480.6,669l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6
		c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L480.6,669z M480.9,671.7h2.8v1.1h-2.8V671.7z M477.2,673.9h1.8v2.8h-1.8V673.9z M485,677.2
		h-5.5v-3.9h5.5V677.2z M488,676.6h-2.5v-2.8h2.5V676.6z M489.9,677.7h-1.4v-4.9h1.4L489.9,677.7z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(31)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(31)">
	<circle class="st3" cx="427.1" cy="667.1" r="14.5"/>
	<circle class="st4" cx="427.1" cy="667.1" r="13"/>
	<circle class="st5" cx="427.1" cy="667.1" r="11.7"/>
	<path class="st6" d="M427.1,679.6c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C439.5,674,433.9,679.6,427.1,679.6z M427.1,656.1c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C438.1,661,433.2,656.1,427.1,656.1L427.1,656.1z"/>
	<path class="st7" d="M434.6,666.8h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8V664h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8V667c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0V667C434.9,666.9,434.7,666.8,434.6,666.8
		C434.6,666.8,434.6,666.8,434.6,666.8z M427.5,662.9h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8
		l0,0h-0.1h-0.1l-1.7-0.3h-0.9L427.5,662.9z M421.1,672.2h-1.4v-4.9h1.4V672.2z M426.4,662.1h0.6v0.3h-0.6V662.1z M426.4,662.9h0.6
		v0.6h-0.6V662.9z M426.4,664h0.6v1.7h-0.6V664z M425.1,663.5L425.1,663.5l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6
		c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L425.1,663.5z M425.3,666.2h2.8v1.1h-2.8V666.2z M421.6,668.3h1.8v2.8
		h-1.8V668.3z M429.5,671.6H424v-3.9h5.5V671.6z M432.5,671.1H430v-2.8h2.5V671.1z M434.4,672.2H433v-4.9h1.4L434.4,672.2z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(32)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(32)">
	<circle class="st3" cx="524.1" cy="718.4" r="14.5"/>
	<circle class="st4" cx="524.1" cy="718.4" r="13"/>
	<circle class="st5" cx="524.1" cy="718.4" r="11.7"/>
	<path class="st6" d="M524.1,730.9c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C536.5,725.3,531,730.9,524.1,730.9z M524.1,707.4c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C535.2,712.3,530.2,707.4,524.1,707.4L524.1,707.4z"/>
	<path class="st7" d="M531.7,718.1h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8H527v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C531.9,718.2,531.8,718.1,531.7,718.1
		C531.7,718.1,531.7,718.1,531.7,718.1z M524.6,714.2h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8
		l0,0h-0.1h-0.1l-1.7-0.3h-0.9V714.2z M518.2,723.5h-1.4v-4.9h1.4V723.5z M523.5,713.4h0.6v0.3h-0.6V713.4z M523.5,714.2h0.6v0.6
		h-0.6V714.2z M523.5,715.3h0.6v1.7h-0.6V715.3z M522.1,714.8L522.1,714.8l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6
		c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L522.1,714.8z M522.4,717.5h2.8v1.1h-2.8V717.5z M518.7,719.6h1.8v2.8
		h-1.8V719.6z M526.5,722.9h-5.5v-3.9h5.5V722.9z M529.5,722.4H527v-2.8h2.5V722.4z M531.4,723.5H530v-4.9h1.4L531.4,723.5z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(25)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(25)">
	<circle class="st3" cx="701.3" cy="673.2" r="14.5"/>
	<circle class="st4" cx="701.3" cy="673.2" r="13"/>
	<circle class="st5" cx="701.3" cy="673.2" r="11.7"/>
	<path class="st6" d="M701.3,685.6c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C713.7,680,708.2,685.6,701.3,685.6z M701.3,662.1c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C712.4,667.1,707.4,662.1,701.3,662.1L701.3,662.1z"/>
	<path class="st7" d="M708.9,672.8h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1V672
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8V670h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0v1.4H698
		c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8V673c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3
		h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8
		c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0V673C709.1,672.9,709,672.8,708.9,672.8
		C708.9,672.8,708.9,672.8,708.9,672.8z M701.8,669h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5s-0.2,0.7-0.5,0.8l0,0h-0.1
		h-0.1l-1.7-0.3h-0.9V669z M695.4,678.2H694v-4.9h1.4V678.2z M700.7,668.1h0.6v0.3h-0.6V668.1z M700.7,668.9h0.6v0.6h-0.6V668.9z
		 M700.7,670h0.6v1.7h-0.6V670z M699.3,669.5L699.3,669.5l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6
		c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L699.3,669.5z M699.6,672.2h2.8v1.1h-2.8V672.2z M695.9,674.3h1.8v2.8h-1.8V674.3z M703.7,677.7
		h-5.5v-3.9h5.5V677.7z M706.7,677.1h-2.5v-2.8h2.5V677.1z M708.6,678.2h-1.4v-4.9h1.4L708.6,678.2z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(22)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(22)">
	<circle class="st3" cx="791.3" cy="641.2" r="14.5"/>
	<circle class="st4" cx="791.3" cy="641.2" r="13"/>
	<circle class="st5" cx="791.3" cy="641.2" r="11.7"/>
	<path class="st6" d="M791.3,653.6c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C803.7,648,798.1,653.6,791.3,653.6z M791.3,630.1c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C802.3,635,797.4,630.1,791.3,630.1L791.3,630.1z"/>
	<path class="st7" d="M798.8,640.8h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8V638h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4H788c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8V641c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0V641C799.1,640.9,799,640.8,798.8,640.8
		C798.8,640.8,798.8,640.8,798.8,640.8z M791.7,636.9h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8
		l0,0h-0.1h-0.1l-1.7-0.3h-0.9L791.7,636.9z M785.4,646.2h-1.4v-4.9h1.4V646.2z M790.6,636.1h0.6v0.3h-0.6V636.1z M790.6,636.9h0.6
		v0.6h-0.6V636.9z M790.6,638h0.6v1.7h-0.6V638z M789.3,637.5L789.3,637.5l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6
		c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L789.3,637.5z M789.5,640.2h2.8v1.1h-2.8V640.2z M785.8,642.3h1.8v2.8
		h-1.8V642.3z M793.7,645.7h-5.5v-3.9h5.5V645.7z M796.7,645.1h-2.5v-2.8h2.5V645.1z M798.6,646.2h-1.4v-4.9h1.4L798.6,646.2z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(21)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(21)">
	<circle class="st3" cx="719.8" cy="632.7" r="14.5"/>
	<circle class="st4" cx="719.8" cy="632.7" r="13"/>
	<circle class="st5" cx="719.8" cy="632.7" r="11.7"/>
	<path class="st6" d="M719.8,645.1c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C732.2,639.6,726.7,645.1,719.8,645.1z M719.8,621.6c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C730.9,626.6,725.9,621.6,719.8,621.6L719.8,621.6z"/>
	<path class="st7" d="M727.3,632.3h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		L721,628h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C727.6,632.4,727.5,632.3,727.3,632.3
		C727.4,632.3,727.4,632.3,727.3,632.3z M720.3,628.5h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8
		l0,0H723h-0.1l-1.7-0.3h-0.9L720.3,628.5z M713.9,637.7h-1.4v-4.9h1.4V637.7z M719.2,627.6h0.6v0.3h-0.6V627.6z M719.2,628.5h0.6
		v0.6h-0.6V628.5z M719.2,629.5h0.6v1.7h-0.6V629.5z M717.8,629.1L717.8,629.1l-1.7,0.3H716c-0.4,0-0.6-0.3-0.7-0.6
		c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L717.8,629.1z M718.1,631.7h2.8v1.1h-2.8V631.7z M714.4,633.9h1.8v2.8
		h-1.8V633.9z M722.2,637.2h-5.5v-3.9h5.5V637.2z M725.2,636.7h-2.5v-2.8h2.5V636.7z M727.1,637.7h-1.4v-4.9h1.4L727.1,637.7z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(23)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(23)">
	<circle class="st3" cx="672.9" cy="656.1" r="14.5"/>
	<circle class="st4" cx="672.9" cy="656.1" r="13"/>
	<circle class="st5" cx="672.9" cy="656.1" r="11.7"/>
	<g>
		<path class="st6" d="M672.9,668.5c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
			C685.4,662.9,679.8,668.5,672.9,668.5z M672.9,645c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
			c0,0,0,0,0,0C684,650,679.1,645,672.9,645L672.9,645z"/>
		<g>
			<path class="st7" d="M676.6,654.4c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1c0,0,0,0,0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				c0,0,0,0,0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1
				c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1
				c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.7-0.5,0.9-0.9C676.8,654.8,676.8,654.5,676.6,654.4z"/>
			<path class="st7" d="M668.7,652.6c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C668.7,652.2,668.6,652.4,668.7,652.6C668.7,652.6,668.7,652.6,668.7,652.6z"
				/>
			<path class="st7" d="M680,650.9h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5v0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C680.6,651.1,680.3,650.9,680,650.9z M679.8,660.5H679v0h-10.8v0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8c0.6,0,6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4V660.5z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(27)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(27)">
	<circle class="st3" cx="690.5" cy="629.4" r="14.5"/>
	<circle class="st4" cx="690.5" cy="629.4" r="13"/>
	<circle class="st5" cx="690.5" cy="629.4" r="11.7"/>
	<path class="st6" d="M690.5,641.9c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C703,636.3,697.4,641.9,690.5,641.9z M690.5,618.4c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C701.6,623.3,696.7,618.4,690.5,618.4L690.5,618.4z"/>
	<polygon class="st7" points="690.5,629.4 690.5,629.4 690.5,629.4 	"/>
	<g>
		<g>
			<g>
				<path d="M694.6,624.4h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C695.9,625,695.3,624.4,694.6,624.4z M688.4,624.2h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2V624.2z M695.3,635.1c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3V625h1.2c0.4,0,0.7,0.3,0.7,0.7L695.3,635.1
					L695.3,635.1z"/>
				<path d="M689.3,629.9c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C689.4,630.2,689.4,630,689.3,629.9C689.3,629.9,689.3,629.9,689.3,629.9z
					"/>
				<path d="M694,630.6h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S694.1,630.6,694,630.6z"/>
				<path d="M689.3,627.3c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C689.4,627.6,689.4,627.4,689.3,627.3
					C689.3,627.3,689.3,627.3,689.3,627.3z"/>
				<path d="M694,628h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S694.1,628,694,628z"/>
				<path d="M689.3,632.5c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C689.4,632.8,689.4,632.6,689.3,632.5
					C689.3,632.5,689.3,632.5,689.3,632.5z"/>
				<path d="M694,633.2h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S694.1,633.2,694,633.2z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(28)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(28)">
	<circle class="st3" cx="728.6" cy="660.8" r="14.5"/>
	<circle class="st4" cx="728.6" cy="660.8" r="13"/>
	<circle class="st5" cx="728.6" cy="660.8" r="11.7"/>
	<path class="st6" d="M728.6,673.2c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4s12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C741,667.6,735.5,673.2,728.6,673.2z M728.6,649.7c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C739.7,654.6,734.7,649.7,728.6,649.7L728.6,649.7z"/>
	<polygon class="st7" points="728.6,660.8 728.6,660.8 728.6,660.8 	"/>
	<g>
		<g>
			<g>
				<path d="M732.6,655.7h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2V657
					C733.9,656.3,733.3,655.7,732.6,655.7z M726.5,655.5h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2V655.5z M733.3,666.4c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6V657
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7V666.4
					L733.3,666.4z"/>
				<path d="M727.3,661.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C727.5,661.5,727.5,661.3,727.3,661.2
					C727.4,661.2,727.3,661.2,727.3,661.2z"/>
				<path d="M732,661.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C732.3,662,732.2,661.9,732,661.9z"/>
				<path d="M727.3,658.6c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C727.5,658.9,727.5,658.7,727.3,658.6
					C727.4,658.6,727.3,658.6,727.3,658.6z"/>
				<path d="M732,659.3h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C732.3,659.4,732.2,659.3,732,659.3z"/>
				<path d="M727.3,663.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C727.5,664.2,727.5,664,727.3,663.8C727.4,663.8,727.3,663.8,727.3,663.8z
					"/>
				<path d="M732,664.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C732.3,664.7,732.2,664.5,732,664.5z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g  @click="mostarIntervencao(39)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(39)">
	<circle class="st3" cx="501" cy="695.3" r="14.5"/>
	<circle class="st4" cx="501" cy="695.3" r="13"/>
	<circle class="st5" cx="501" cy="695.3" r="11.7"/>
	<path class="st6" d="M501,707.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C513.4,702.2,507.9,707.7,501,707.7z M501,684.2c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C512.1,689.2,507.1,684.2,501,684.2L501,684.2z"/>
	<polygon class="st7" points="501,695.3 501,695.3 501,695.3 	"/>
	<g>
		<g>
			<g>
				<path d="M505,690.2h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9c-0.2,0-0.4,0.1-0.4,0.3
					v0.6H497c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4C506.4,690.8,505.8,690.2,505,690.2z
					 M498.9,690.1h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2
					V690.1z M505.8,700.9c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8
					c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L505.8,700.9L505.8,700.9z"/>
				<path d="M499.8,695.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C499.9,696.1,499.9,695.9,499.8,695.7
					C499.8,695.8,499.8,695.7,499.8,695.7z"/>
				<path d="M504.4,696.4h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S504.6,696.4,504.4,696.4z"/>
				<path d="M499.8,693.1c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C499.9,693.5,499.9,693.3,499.8,693.1
					C499.8,693.1,499.8,693.1,499.8,693.1z"/>
				<path d="M504.4,693.8h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C504.8,694,504.6,693.8,504.4,693.8z"/>
				<path d="M499.8,698.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C499.9,698.7,499.9,698.5,499.8,698.4
					C499.8,698.4,499.8,698.4,499.8,698.4z"/>
				<path d="M504.4,699.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S504.6,699.1,504.4,699.1z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(20)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(20)">
	<circle class="st3" cx="515.2" cy="344.4" r="14.5"/>
	<circle class="st4" cx="515.2" cy="344.4" r="13"/>
	<circle class="st5" cx="515.2" cy="344.4" r="11.7"/>
	<path class="st6" d="M515.2,356.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C527.6,351.2,522,356.8,515.2,356.8z M515.2,333.3c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C526.2,338.2,521.3,333.3,515.2,333.3L515.2,333.3z"/>
	<polygon class="st7" points="515.2,344.4 515.2,344.4 515.2,344.4 	"/>
	<g>
		<g>
			<g>
				<path d="M519.2,339.3h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C520.5,339.9,519.9,339.3,519.2,339.3z M513,339.1h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3H513V339.1z M519.9,350c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3V340h1.2c0.4,0,0.7,0.3,0.7,0.7V350L519.9,350z
					"/>
				<path d="M513.9,344.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C514,345.1,514,344.9,513.9,344.8C513.9,344.8,513.9,344.8,513.9,344.8z"
					/>
				<path d="M518.6,345.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C518.9,345.6,518.8,345.5,518.6,345.5z"/>
				<path d="M513.9,342.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C514,342.5,514,342.3,513.9,342.2C513.9,342.2,513.9,342.2,513.9,342.2z"
					/>
				<path d="M518.6,342.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C518.9,343,518.8,342.9,518.6,342.9z"/>
				<path d="M513.9,347.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C514,347.7,514,347.6,513.9,347.4C513.9,347.4,513.9,347.4,513.9,347.4z"
					/>
				<path d="M518.6,348.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C518.9,348.3,518.8,348.1,518.6,348.1z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(38)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(38)">
	<circle class="st3" cx="402.7" cy="609" r="14.5"/>
	<circle class="st4" cx="402.7" cy="609" r="13"/>
	<circle class="st5" cx="402.7" cy="609" r="11.7"/>
	<path class="st6" d="M402.7,621.4c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C415.1,615.9,409.5,621.4,402.7,621.4z M402.7,597.9c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1s11.1-5,11.1-11.1c0,0,0,0,0,0
		C413.7,602.9,408.8,597.9,402.7,597.9L402.7,597.9z"/>
	<polygon class="st7" points="402.7,609 402.7,609 402.7,609 	"/>
	<g>
		<g>
			<g>
				<path d="M406.7,604h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9c-0.2,0-0.4,0.1-0.4,0.3
					v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4C408,604.5,407.4,604,406.7,604z
					 M400.5,603.8h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2
					V603.8z M407.4,614.6c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8
					c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L407.4,614.6L407.4,614.6z"/>
				<path d="M401.4,609.5c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C401.5,609.8,401.5,609.6,401.4,609.5
					C401.4,609.5,401.4,609.5,401.4,609.5z"/>
				<path d="M406.1,610.2h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C406.4,610.3,406.3,610.2,406.1,610.2z"/>
				<path d="M401.4,606.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C401.5,607.2,401.5,607,401.4,606.8C401.4,606.9,401.4,606.9,401.4,606.8z
					"/>
				<path d="M406.1,607.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C406.4,607.7,406.3,607.5,406.1,607.5z"/>
				<path d="M401.4,612.1c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C401.5,612.4,401.5,612.2,401.4,612.1
					C401.4,612.1,401.4,612.1,401.4,612.1z"/>
				<path d="M406.1,612.8h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S406.3,612.8,406.1,612.8z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(37)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(37)">
	<circle class="st3" cx="262.9" cy="628.3" r="14.5"/>
	<circle class="st4" cx="262.9" cy="628.3" r="13"/>
	<circle class="st5" cx="262.9" cy="628.3" r="11.7"/>
	<path class="st6" d="M262.9,640.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C275.3,635.2,269.8,640.7,262.9,640.7z M262.9,617.2c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C274,622.2,269,617.2,262.9,617.2L262.9,617.2z"/>
	<polygon class="st7" points="262.9,628.3 262.9,628.3 262.9,628.3 	"/>
	<g>
		<g>
			<g>
				<path d="M266.9,623.2h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C268.3,623.8,267.7,623.3,266.9,623.2z M260.8,623.1h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2V623.1z M267.6,633.9c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L267.6,633.9
					L267.6,633.9z"/>
				<path d="M261.7,628.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C261.8,629.1,261.8,628.9,261.7,628.7
					C261.7,628.8,261.7,628.8,261.7,628.7z"/>
				<path d="M266.3,629.4h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C266.7,629.6,266.5,629.4,266.3,629.4z"/>
				<path d="M261.7,626.1c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C261.8,626.5,261.8,626.3,261.7,626.1
					C261.7,626.1,261.7,626.1,261.7,626.1z"/>
				<path d="M266.3,626.8h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S266.5,626.8,266.3,626.8z"/>
				<path d="M261.7,631.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C261.8,631.7,261.8,631.5,261.7,631.4
					C261.7,631.4,261.7,631.4,261.7,631.4z"/>
				<path d="M266.3,632.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C266.7,632.2,266.5,632.1,266.3,632.1z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(19)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(19)">
	<circle class="st3" cx="513" cy="531.5" r="14.5"/>
	<circle class="st4" cx="513" cy="531.5" r="13"/>
	<circle class="st5" cx="513" cy="531.5" r="11.7"/>
	<path class="st6" d="M513,543.9c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C525.5,538.3,519.9,543.9,513,543.9z M513,520.4c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C524.1,525.3,519.2,520.4,513,520.4L513,520.4z"/>
	<polygon class="st7" points="513,531.5 513,531.5 513,531.5 	"/>
	<g>
		<g>
			<g>
				<path d="M517.1,526.4h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6H509c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C518.4,527,517.8,526.4,517.1,526.4z M510.9,526.2h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2V526.2z M517.8,537.1c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L517.8,537.1
					L517.8,537.1z"/>
				<path d="M511.8,531.9c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C511.9,532.2,511.9,532,511.8,531.9C511.8,531.9,511.8,531.9,511.8,531.9z
					"/>
				<path d="M516.5,532.6h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S516.6,532.6,516.5,532.6z"/>
				<path d="M511.8,529.3c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C511.9,529.6,511.9,529.4,511.8,529.3
					C511.8,529.3,511.8,529.3,511.8,529.3z"/>
				<path d="M516.5,530h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C516.8,530.1,516.6,530,516.5,530z"/>
				<path d="M511.8,534.5c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C511.9,534.9,511.9,534.7,511.8,534.5
					C511.8,534.5,511.8,534.5,511.8,534.5z"/>
				<path d="M516.5,535.2h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S516.6,535.2,516.5,535.2z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(18)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(18)">
	<circle class="st3" cx="655.1" cy="477.4" r="14.5"/>
	<circle class="st4" cx="655.1" cy="477.4" r="13"/>
	<circle class="st5" cx="655.1" cy="477.4" r="11.7"/>
	<path class="st6" d="M655.1,489.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C667.5,484.3,662,489.8,655.1,489.8z M655.1,466.3c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C666.2,471.3,661.2,466.3,655.1,466.3L655.1,466.3z"/>
	<polygon class="st7" points="655.1,477.4 655.1,477.4 655.1,477.4 	"/>
	<g>
		<g>
			<g>
				<path d="M659.1,472.3h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C660.5,472.9,659.9,472.3,659.1,472.3z M653,472.2h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3H653V472.2z M659.8,483c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3V473h1.2c0.4,0,0.7,0.3,0.7,0.7L659.8,483
					L659.8,483z"/>
				<path d="M653.9,477.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C654,478.2,654,478,653.9,477.8C653.9,477.8,653.9,477.8,653.9,477.8z"/>
				<path d="M658.5,478.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C658.9,478.7,658.7,478.5,658.5,478.5z"/>
				<path d="M653.9,475.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C654,475.6,654,475.4,653.9,475.2C653.9,475.2,653.9,475.2,653.9,475.2z"
					/>
				<path d="M658.5,475.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C658.9,476.1,658.7,475.9,658.5,475.9z"/>
				<path d="M653.9,480.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C654,480.8,654,480.6,653.9,480.4C653.9,480.5,653.9,480.5,653.9,480.4z"
					/>
				<path d="M658.5,481.2h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C658.9,481.3,658.7,481.2,658.5,481.2z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(17)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(17)">
	<circle class="st3" cx="734.3" cy="351.2" r="14.5"/>
	<circle class="st4" cx="734.3" cy="351.2" r="13"/>
	<circle class="st5" cx="734.3" cy="351.2" r="11.7"/>
	<path class="st6" d="M734.3,363.6c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C746.7,358.1,741.2,363.6,734.3,363.6z M734.3,340.1c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1c0,0,0,0,0,0
		C745.4,345.1,740.4,340.1,734.3,340.1L734.3,340.1z"/>
	<polygon class="st7" points="734.3,351.2 734.3,351.2 734.3,351.2 	"/>
	<g>
		<g>
			<g>
				<path d="M738.3,346.2h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C739.7,346.7,739.1,346.2,738.3,346.2z M732.2,346h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2V346z M739,356.8c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L739,356.8
					L739,356.8z"/>
				<path d="M733.1,351.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C733.2,352,733.2,351.8,733.1,351.7C733.1,351.7,733.1,351.7,733.1,351.7z
					"/>
				<path d="M737.7,352.4H734c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C738.1,352.5,737.9,352.4,737.7,352.4z"/>
				<path d="M733.1,349c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C733.2,349.4,733.2,349.2,733.1,349C733.1,349.1,733.1,349,733.1,349z"/>
				<path d="M737.7,349.7H734c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C738.1,349.9,737.9,349.7,737.7,349.7z"/>
				<path d="M733.1,354.3c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C733.2,354.6,733.2,354.4,733.1,354.3
					C733.1,354.3,733.1,354.3,733.1,354.3z"/>
				<path d="M737.7,355H734c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C738.1,355.1,737.9,355,737.7,355z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(16)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(16)">
	<circle class="st3" cx="678.1" cy="233.5" r="14.5"/>
	<circle class="st4" cx="678.1" cy="233.5" r="13"/>
	<circle class="st5" cx="678.1" cy="233.5" r="11.7"/>
	<path class="st6" d="M678.1,245.9c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C690.5,240.3,685,245.9,678.1,245.9z M678.1,222.4c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C689.2,227.4,684.2,222.4,678.1,222.4L678.1,222.4z"/>
	<polygon class="st7" points="678.1,233.5 678.1,233.5 678.1,233.5 	"/>
	<g>
		<g>
			<g>
				<path d="M682.1,228.4h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C683.5,229,682.9,228.4,682.1,228.4z M676,228.2h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3H676V228.2z M682.8,239.1c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7V239.1
					L682.8,239.1z"/>
				<path d="M676.9,233.9c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C677,234.3,677,234.1,676.9,233.9C676.9,233.9,676.9,233.9,676.9,233.9z"
					/>
				<path d="M681.5,234.6h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S681.7,234.6,681.5,234.6z"/>
				<path d="M676.9,231.3c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C677,231.6,677,231.4,676.9,231.3C676.9,231.3,676.9,231.3,676.9,231.3z"
					/>
				<path d="M681.5,232h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S681.7,232,681.5,232z"/>
				<path d="M676.9,236.5c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C677,236.9,677,236.7,676.9,236.5C676.9,236.5,676.9,236.5,676.9,236.5z"
					/>
				<path d="M681.5,237.2h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S681.7,237.2,681.5,237.2z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(15)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(15)">
	<circle class="st3" cx="834.3" cy="302.8" r="14.5"/>
	<circle class="st4" cx="834.3" cy="302.8" r="13"/>
	<circle class="st5" cx="834.3" cy="302.8" r="11.7"/>
	<path class="st6" d="M834.3,315.2c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C846.7,309.7,841.1,315.2,834.3,315.2z M834.3,291.7c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1s11.1-5,11.1-11.1c0,0,0,0,0,0
		C845.4,296.7,840.4,291.7,834.3,291.7L834.3,291.7z"/>
	<polygon class="st7" points="834.3,302.8 834.3,302.8 834.3,302.8 	"/>
	<g>
		<g>
			<g>
				<path d="M838.3,297.7h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C839.6,298.3,839,297.7,838.3,297.7z M832.2,297.6h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2V297.6z M839,308.4c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7V308.4
					L839,308.4z"/>
				<path d="M833,303.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C833.2,303.6,833.2,303.4,833,303.2C833,303.2,833,303.2,833,303.2z"/>
				<path d="M837.7,303.9H834c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C838,304.1,837.9,303.9,837.7,303.9z"/>
				<path d="M833,300.6c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C833.2,301,833.2,300.8,833,300.6C833,300.6,833,300.6,833,300.6z"/>
				<path d="M837.7,301.3H834c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C838,301.5,837.9,301.3,837.7,301.3z"/>
				<path d="M833,305.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C833.2,306.2,833.2,306,833,305.8C833,305.9,833,305.9,833,305.8z"/>
				<path d="M837.7,306.6H834c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C838,306.7,837.9,306.6,837.7,306.6z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
</svg>
         </SvgPanZoom>
      </div>
    </div>
  </div>
</template>


<script>
import SvgPanZoom from 'vue-svg-pan-zoom';
import { mapActions } from 'vuex'
import Modal from '@/components/ModalMapas.vue'

export default {
	components: { SvgPanZoom, Modal },


	data () {
		return {
			informacoes: [
              {
                id: 1,
                titulo: 'Sistema Adutor Capim Branco',
                desc: 'Abastecimento humano de Uberlândia',
                estagio: 'Obra',
                valor: 'R$ 88,61 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_MG-001.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 2,
                titulo: 'Sistema Adutor Congonhas-Montes Claros',
                desc: 'Abastecimento humano de Montes Claros',
                estagio: 'Obra',
                valor: 'R$ 111,14 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_MG-002_MG-013.pdf',
                posicao: {
                  top: 60,
                  left: 20,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 3,
                titulo: 'Sistema Adutor de Governador Valadares (ampliação)',
                desc: 'Abastecimento humano de Governador Valadares',
                estagio: 'Obra',
                valor: 'R$ 163,53 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_MG-003.pdf',
                posicao: {
                  top: 60,
                  left: 20,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 4,
                titulo: 'Sistema Adutor de Uberaba (ampliação)',
                desc: 'Abastecimento humano de Uberaba',
                estagio: 'Obra',
                valor: 'R$ 18,82 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_MG-004.pdf',
                posicao: {
                  top: 30,
                  left: 25,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 5,
                titulo: 'Sistema Adutor de Itabira (ampliação)',
                desc: 'Abastecimento humano de Itabira',
                estagio: 'Obra',
                valor: 'R$ 7,77 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_MG-007.pdf',
                posicao: {
                  top: 30,
                  left: 25,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 6,
                titulo: 'Barragem Carangola',
                desc: 'Controle de cheias em Carangola',
                estagio: 'EVTEA',
                valor: 'R$ 7,95 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_Paraiba_do_Sul.pdf',
                posicao: {
                  top: 30,
                  left: 25,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 7,
                titulo: 'Barragem Tombos',
                desc: 'Controle de cheias em Tombos',
                estagio: 'EVTEA',
                valor: 'R$ 7,95 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_Paraiba_do_Sul.pdf',
                posicao: {
                  top: 30,
                  left: 25,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 8,
                titulo: 'Barragem Congonhas',
                desc: 'Abastecimento humano, irrigação e dessedentação animal nos municípios de Monte Claros, Francisco Sá, Juramento, Grão Mogol, Itacambira e Capitão Enéas',
                estagio: 'Obra',
                valor: 'R$ 225,27 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_MG-002_MG-013.pdf',
                posicao: {
                  top: 30,
                  left: 25,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 9,
                titulo: 'Barragem Prainha',
                desc: 'Abastecimento humano de Uberaba',
                estagio: 'Obra',
                valor: 'R$ 27,48 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_MG-015.pdf',
                posicao: {
                  top: 30,
                  left: 25,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 10,
                titulo: 'Barragem Xopotó',
                desc: 'Controle de cheias em Cataguases',
                estagio: 'EVTEA',
                valor: 'R$ 7,95 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_Paraiba_do_Sul.pdf',
                posicao: {
                  top: 30,
                  left: 25,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 11,
                titulo: 'Sistema de Controle de Cheias rio Muriaé e Preto',
                desc: 'Controle de cheias em Muriaé',
                estagio: 'EVTEA',
                valor: 'R$ 7,95 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_Paraiba_do_Sul.pdf',
                posicao: {
                  top: 30,
                  left: 25,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 12,
                titulo: 'Barragem Muriaé',
                desc: 'Controle de cheias em Muriaé',
                estagio: 'EVTEA',
                valor: 'R$ 7,95 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_Paraiba_do_Sul.pdf',
                posicao: {
                  top: 30,
                  left: 25,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 13,
                titulo: 'Barragem Jequitaí I',
                desc: 'Irrigação e Usos múltiplos em Montes Claros, Claro dos Poções, Engenheiro Navarro, Francisco Dumont, Jequitai, Lagoa dos Patos, Várzea da Palma, Pirapora e mais 4 municípios',
                estagio: 'EVTEA',
                valor: 'R$ 3,14 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_MG-011_MG-012.pdf',
                posicao: {
                  top: 30,
                  left: 25,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 14,
                titulo: 'Barragem Jequitaí II',
                desc: 'Irrigação e Usos múltiplos em Montes Claros, Claro dos Poções, Engenheiro Navarro, Francisco Dumont, Jequitai, Lagoa dos Patos, Várzea da Palma, Pirapora e mais quatro municípios',
                estagio: 'EVTEA',
                valor: 'R$ 1,58 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_MG-011_MG-012.pdf',
                posicao: {
                  top: 30,
                  left: 25,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 15,
                titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica - Bacias Hidrográficas dos rios Pardo e Jequitinhonha',
                desc: 'Definição de alternativas de aproveitamento de recursos hídricos para suprimento dos deficits em áreas de baixo grau de segurança hídrica nas bacias dos rios Pardo e Jequitinhonha',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 1,80 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-Bacias Pardo e Jequitinhonha.pdf',
                posicao: {
                  top: 40,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 16,
                titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica – Bacia Hidrográfica do rio Verde Grande',
                desc: 'Definição de alternativas de aproveitamento de recursos hídricos para suprimento dos deficits em áreas de baixo grau de segurança hídrica na bacia hidrográfica do rio Verde Grande',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 1,80 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-Bacia Verde Grande.pdf',
                posicao: {
                  top: 40,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 17,
                titulo: 'Estudo de Refinamento do Índice de Segurança Hídrica em Unidades Territoriais de Análise',
                desc: 'Refinamento do ISH de modo a confirmar os deficits hídricos identificados no PNSH',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 0,80 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR_Lacunas-Geral.pdf',
                posicao: {
                  top: 40,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 18,
                titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM Belo Horizonte',
                desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de Belo Horizonte',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 4,80 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Belo Horizonte.pdf',
                posicao: {
                  top: 40,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 19,
                titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica – Bacias Hidrográficas dos rio Paranaíba, Grande e Paranapanema',
                desc: 'Definição de alternativas de aproveitamento de recursos hídricos para suprim. dos deficits em áreas de baixo grau de segurança hídrica nas bacias dos rio Paranaíba, Grande e Paranapanema',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 1,80 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-Bacias Paranaiba Grande e Panema.pdf',
                posicao: {
                  top: 40,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 20,
                titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica – Margem Esquerda do rio São Francisco',
                desc: 'Definição de alternativas de aproveitamento de recursos hídricos para suprimento dos deficits em áreas de baixo grau de segurança hídrica na margem esquerda do rio São Francisco',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 1,80 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-Margem Esquerda do SF.pdf',
                posicao: {
                  top: 40,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 21,
                titulo: 'Sistema Adutor Imunana-Laranjal (ampliação)',
                desc: 'Abastecimento humano de Niterói, São Gonçalo, Itaboraí e Ilha de Paquetá',
                estagio: 'Projeto Executivo',
                valor: 'R$ 268,85 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RJ-002_009_Uni_LP.pdf',
                posicao: {
                  top: 40,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 22,
                titulo: 'Sistema Adutor Prolagos (ampliação)',
                desc: 'Abastecimento humano de Cabo Frio, Armação dos Búzios, Iguaba Grande, São Pedro da Aldeia e Arraial do Cabo',
                estagio: 'Obra',
                valor: 'R$ 85,98 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RJ-003.pdf',
                posicao: {
                  top: 40,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 23,
                titulo: 'Desvio dos rios Poços, Queimados e Ipiranga',
                desc: 'Abastecimento humano de Belford Roxo, Duque de Caxias, Japeri, Nilópolis, São João de Meriti, Nova Iguaçu, Queimados, Mesquita e parte do Rio de Janeiro',
                estagio: 'Obra',
                valor: 'R$ 56,83 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RJ-006_Uni_LP.pdf',
                posicao: {
                  top: 40,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 24,
                titulo: 'Barragem Guapiaçu',
                desc: 'Abastecimento humano de Niterói, São Gonçalo, Itaboraí e Ilha de Paquetá',
                estagio: 'Projeto Executivo',
                valor: 'R$ 281,05 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RJ-002_009_Uni_LP.pdf',
                posicao: {
                  top: 35,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 25,
                titulo: 'Sistema Produtor Guandu (ampliação ETA Nova Guandu)',
                desc: 'Abastecimento humano da Região Metropolitana do Rio de Janeiro',
                estagio: 'Projeto Executivo',
                valor: 'R$ 4.439,75 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RJ-012_Uni_LP.pdf',
                posicao: {
                  top: 35,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 26,
                titulo: 'Barragem de Itaperuna',
                desc: 'Controle de cheias em Itaperuna',
                estagio: 'EVTEA',
                valor: 'R$ 7,95 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_Paraiba_do_Sul.pdf',
                posicao: {
                  top: 35,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 27,
                titulo: 'Estudo de Refinamento do Índice de Segurança Hídrica em Unidades Territoriais de Análise',
                desc: 'Refinamento do ISH de modo a confirmar os deficits hídricos identificados no PNSH',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 0,80 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR_Lacunas-Geral.pdf',
                posicao: {
                  top: 35,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 28,
                titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM Rio de Janeiro',
                desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana do Rio de Janeiro',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 4,80 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Rio de Janeiro.pdf',
                posicao: {
                  top: 35,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 29,
                titulo: 'Sistema Adutor de São José do Rio Preto',
                desc: 'Abastecimento humano de São José do Rio Preto',
                estagio: 'Projeto Básico',
                valor: 'R$ 361,18 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_SP-011.pdf',
                posicao: {
                  top: 35,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 30,
                titulo: 'Sistema Adutor Regional PCJ',
                desc: 'Abastecimento humano e usos múltiplos nos municípios de Amparo, Pedreira, Limeira, Jaguariúna, Artur Nogueira e outros municípios da região da macrometrópole paulista',
                estagio: 'Anteprojeto',
                valor: 'R$ 724,31 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_SP-012_037_038_Uni_LP.pdf',
                posicao: {
                  top: 35,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 31,
                titulo: 'Sistema Adutor/Esquema Sarapuí-Sorocaba-Salto-Reservatório Piraí-Indaiatuba',
                desc: 'Abastecimento humano e usos múltiplos no municípios de Itu, Salto, Indaiatuba, Cabreúva e Campinas',
                estagio: 'Anteprojeto',
                valor: 'R$ 467,58 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_SP-016_040_Uni_LP.pdf',
                posicao: {
                  top: 35,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 32,
                titulo: 'Sistema Adutor do Guarujá (ampliação)',
                desc: 'Abastecimento humano de Guarujá e Bertioga',
                estagio: 'Anteprojeto',
                valor: 'R$ 125,19 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_SP-019.pdf',
                posicao: {
                  top: 35,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 33,
                titulo: 'Barragem Duas Pontes',
                desc: 'Abastecimento humano e usos múltiplos em 23 municípios na Bacia do PCJ',
                estagio: 'Obra',
                valor: 'R$ 206,87 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_SP-012_037_038_Uni_LP.pdf',
                posicao: {
                  top: 35,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 34,
                titulo: 'Barragem Pedreira',
                desc: 'Abastecimento humano e usos múltiplos em 23 municípios na Bacia do PCJ',
                estagio: 'Obra',
                valor: 'R$ 243,60 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_SP-012_037_038_Uni_LP.pdf',
                posicao: {
                  top: 35,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 35,
                titulo: 'Barragem Ribeirão Piraí',
                desc: 'Abastecimento humano e controle de cheias em Itu, Salto, Indaiatuba e Cabreúva',
                estagio: 'Obra',
                valor: 'R$ 131,71 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_SP-016_040_Uni_LP.pdf',
                posicao: {
                  top: 25,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 36,
                titulo: 'Sistema Adutor de Ribeirão Preto',
                desc: 'Abastecimento humano de Ribeirão Preto',
                estagio: 'Projeto Básico',
                valor: 'R$ 490,04 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_SP-044.pdf',
                posicao: {
                  top: 40,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 37,
                titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica – Bacias Hidrográficas dos rio Paranaíba, Grande e Paranapanema',
                desc: 'Definição de alternativas de aproveitamento de recursos hídricos para suprim. dos deficits em áreas de baixo grau de segurança hídrica nas bacias dos rio Paranaíba, Grande e Paranapanema',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 1,80 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-Bacias Paranaiba Grande e Panema.pdf',
                posicao: {
                  top: 25,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 38,
                titulo: 'Estudo de Refinamento do Índice de Segurança Hídrica em Unidades Territoriais de Análise',
                desc: 'Refinamento do ISH de modo a confirmar os deficits hídricos identificados no PNSH',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 0,80 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR_Lacunas-Geral.pdf',
                posicao: {
                  top: 25,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 39,
                titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM São Paulo',
                desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de São Paulo',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 4,80 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Sao Paulo.pdf',
                posicao: {
                  top: 25,
                  left: 0,
									right: 0,
									bottom: 0
                },
              },
							{
                id: 40,
                titulo: 'Barragem Pedra Bonita',
                desc: 'Abastecimento humano e usos múltiplos de Cariacica, Vitória, Vila Velha e Região Metropolitana de Vitória',
                estagio: 'Projeto Básico',
                valor: 'R$ 106,15 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_ES-004.pdf',
                posicao: {
                  top: 25,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 41,
                titulo: 'Barragem Ribeirão Piraí',
                desc: 'Abastecimento humano e controle de cheias em Itu, Salto, Indaiatuba e Cabreúva',
                estagio: 'Obra',
                valor: 'R$ 131,71 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_SP-016_040_Uni_LP.pdf',
                posicao: {
                  top: 25,
                  left: 0,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 42,
                titulo: 'Barragem de Laje do Muriaé',
                desc: 'Controle de cheias em Laje do Muriaé',
                estagio: 'EVTEA',
                valor: 'R$ 7,95 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_Paraiba_do_Sul.pdf',
                posicao: {
                  top: 25,
                  left: 0,
									right: 0,
									bottom: 0
                },
              },
          ]
		}
	},

  methods: {
    ...mapActions({
        showModal: 'Layout/enviarInformacaoModal'
    }),
    mostarIntervencao (item, evt) {
      let payload = this.informacoes.filter((value) => {
          return value.id === item
			})

      this.showModal(payload[0]);
    }
  }
}
</script>


<style lang="scss" scoped>

.title-section {
    padding-left: 0px;
    height: 40px;
}

svg {
    height: 450px;
    width: 100%;
    @media (max-height:  900px) and (min-width: 1200px)   {
        height: 350px;
    }
}

.interacao-intervencao {
	display: flex;
	align-items: center;
    width: 289px;
    @include media_tablet() {
      display: none;
    }
	svg {
		width: 22px;
		height: 22px;
		margin-right: 10px;
	}

	p {
		font-family: 'rubik_italic';
		font-size: 12px;
		line-height: 16px;
	}
}

    .st0{fill:#3B6EB6;}
	.st1{fill:#DFEDF3;}
	.st2{fill:none;}
	.st3{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}
	.st4{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}
	.st5{fill:#FFFFFF;}
	.st6{fill:#8FC74B;}
	.st7{fill:#010101;}
</style>
